import { NavigateFunction } from 'react-router-dom';

import { IAuthContext } from 'contexts/Auth';
import axiosInstance from './axiosConfig';
import { API_URL } from './constants';

export default class GeneralApi {
  auth: IAuthContext;
  history: NavigateFunction;
  overrideRole: string;

  constructor(auth: IAuthContext, history: NavigateFunction, overrideRole: string = '') {
    this.auth = auth;
    this.history = history;
    this.overrideRole = overrideRole;
  }

  async get(apiPath: string, params: any = {}) {
    try {
      const isAdmin = this.overrideRole !== '' ? this.overrideRole === 'admin' : this.auth.isAdmin;
      const result = await axiosInstance.get(
        `${API_URL}/${isAdmin ? 'admin/api' : 'api'}${apiPath}`,
        { params }
      );
      return {
        success: true,
        message: 'Pedido correcto',
        data: result.data,
      };
    } catch (error: any) {
      console.log(error);
      if (error.response && error.response.status === 403) {
        this.auth.signout(() => this.history('/', { replace: true }));
        return {
          success: false,
          message: 'Sesión finalizada',
        };
      }
      if (error.response && error.response.status === 402) {
        this.history('/my_courses');
        return {
          success: false,
          message: 'Debe completar sus pagos para acceder a este curso',
        };
      }
      if (error.response && error.response.status === 401) {
        this.history('/my_courses');
        return {
          success: false,
          message: 'No tiene acceso a este curso',
        };
      }
      return {
        success: false,
        message: error.response != null ? error.response.data.message : 'Ocurrió un error',
      };
    }
  }

  async post(apiPath: string, data: any) {
    try {
      const isAdmin = this.overrideRole !== '' ? this.overrideRole === 'admin' : this.auth.isAdmin;
      const result = await axiosInstance.post(
        `${API_URL}/${isAdmin ? 'admin/api' : 'api'}${apiPath}`,
        data
      );
      return {
        success: true,
        message: 'Pedido correcto',
        data: result.data,
      };
    } catch (error: any) {
      console.log(error);
      if (error.response && error.response.status === 403) {
        this.auth.signout(() => this.history('/', { replace: true }));
        return {
          success: false,
          message: 'Sesión finalizada',
        };
      }
      return {
        success: false,
        data: error.response != null ? error.response.data : {},
        status: error.response.status,
        message: error.response != null ? error.response.data.message : 'Ocurrió un error',
      };
    }
  }

  async put(apiPath: string, data: any) {
    try {
      const isAdmin = this.overrideRole !== '' ? this.overrideRole === 'admin' : this.auth.isAdmin;
      const result = await axiosInstance.put(
        `${API_URL}/${isAdmin ? 'admin/api' : 'api'}${apiPath}`,
        data
      );
      return {
        success: true,
        message: 'Pedido correcto',
        data: result.data,
      };
    } catch (error: any) {
      console.log(error);
      if (error.response && error.response.status === 403) {
        this.auth.signout(() => this.history('/', { replace: true }));
        return {
          success: false,
          message: 'Sesión finalizada',
        };
      }
      return {
        success: false,
        message: error.response != null ? error.response.data.message : 'Ocurrió un error',
      };
    }
  }
  async delete(apiPath: string, params: any = {}) {
    try {
      const isAdmin = this.overrideRole !== '' ? this.overrideRole === 'admin' : this.auth.isAdmin;
      const result = await axiosInstance.delete(
        `${API_URL}/${isAdmin ? 'admin/api' : 'api'}${apiPath}`,
        { params }
      );
      return {
        success: true,
        message: 'Pedido correcto',
        data: result.data,
      };
    } catch (error: any) {
      console.log(error);
      if (error.response && error.response.status === 403) {
        this.auth.signout(() => this.history('/', { replace: true }));
        return {
          success: false,
          message: 'Sesión finalizada',
        };
      }
      if (error.response && error.response.status === 402) {
        this.history('/my_courses');
        return {
          success: false,
          message: 'Debe completar sus pagos para acceder a este curso',
        };
      }
      if (error.response && error.response.status === 401) {
        this.history('/my_courses');
        return {
          success: false,
          message: 'No tiene acceso a este curso',
        };
      }
      return {
        success: false,
        message: error.response != null ? error.response.data.message : 'Ocurrió un error',
      };
    }
  }
}
